const DEFAULT_KEYMAP = {
  F2: "focusSearch",
  F4: "openPayment",
  F8: "holdSale",
  F9: "clearCart",
  Escape: "closeModals",
};

export function createPosKeyboardHandler(vm, keymap = DEFAULT_KEYMAP) {
  return function onKeydown(e) {
    if (isTypingInField(e.target) && e.key !== "Escape" && e.key !== "F2") {
      return;
    }

    const action = keymap[e.key];
    if (!action || !vm[action]) return;

    e.preventDefault();
    vm[action]();
  };
}

function isTypingInField(target) {
  if (!target) return false;
  const tag = target.tagName?.toLowerCase();
  return (
    tag === "input" ||
    tag === "textarea" ||
    tag === "select" ||
    target.isContentEditable
  );
}

export const POS_SHORTCUT_HINTS = [
  { key: "F2", label: "Search" },
  { key: "F4", label: "Pay" },
  { key: "F8", label: "Hold" },
  { key: "F9", label: "Clear" },
];
